const LOGIN_FLOW_BASE = 'login/loginFlowStatus';
const LOGIN_CHECK_FLOW_BASE = 'login/loginCheckFlowStatus';
export default Object.freeze({
    LOGIN_FLOW: LOGIN_FLOW_BASE,
    LOGIN_FLOW_PENDING: `${LOGIN_FLOW_BASE}/pending`,
    LOGIN_FLOW_FULFILLED: `${LOGIN_FLOW_BASE}/fulfilled`,
    LOGIN_FLOW_REJECTED: `${LOGIN_FLOW_BASE}/rejected`,
    LOGIN_CHECK_FLOW: LOGIN_CHECK_FLOW_BASE,
    LOGIN_CHECK_FLOW_PENDING: `${LOGIN_CHECK_FLOW_BASE}/pending`,
    LOGIN_CHECK_FLOW_FULFILLED: `${LOGIN_CHECK_FLOW_BASE}/fulfilled`,
    LOGIN_CHECK_FLOW_REJECTED: `${LOGIN_CHECK_FLOW_BASE}/rejected`,
});
